import React, { useEffect, useState } from "react";
import CircleChart from "../../../common/Charts/CircleCharts";
import { Typography, Box } from "@mui/material";
import { fonts, themes } from "../../../common/themes/themes";

interface propsType {
  trans?: any;
}

const GoalsRatioPresenter: React.FC<propsType> = ({ trans }) => {
  const chartData = [
    { name: "Completed", value: 40 },
    { name: "In-Progress", value: 30 },
    { name: "Pending", value: 20 },
  ];

  const chartColors = ["#4CAF50", "#FFB400", "#F44336"];
  return (
    <Box
      style={{
        height: "100%",
        width: "auto",
        padding: "1.75em",
        background: "#ffffff 0% 0% no-repeat padding-box",
        boxShadow: "0px 1px 2px #00000029",
        borderRadius: "15px",
        overflow: "hidden",
      }}
    >
      <Typography
        style={{
          color: themes.blackDefault,
          fontSize: fonts.header,
          fontFamily: fonts.fontFamily,
          fontWeight: "bold",
        }}
      >
        Goals Ratio
      </Typography>{" "}
      <div style={{ width: "100%", position: "relative" }}>
        <CircleChart data={chartData} colors={chartColors} />{" "}
      </div>
    </Box>
  );
};

export default GoalsRatioPresenter;
